var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AsiToolbar',{attrs:{"icon":_vm.icons.reports,"title":_vm.$t('uiTerms.pendingReports')}}),_c('PlanningEntryList',{attrs:{"planning-entry-filter-model":_vm.planningEntryFilterModel,"hide-toolbar":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }